<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      海上田园南站<br>
站点介绍<br>
海上田园南站位于南环路和展城路的交叉口处，沿展城路南北向布置。海上田园南为地下两层岛式车站，其中地下一层为站厅层，地下二层为站台层，站台为岛式站台。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:29	00:09	12号线	4分钟	8分钟<br>
海上田园东	06:22	23:02	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:30	00:09	12号线	8分钟	8分钟<br>
海上田园东	06:22	23:02	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
附近为工地，市政道路在建<br><br>
C出入口:<br>
附近为工地，市政道路在建<br><br>
公交换乘信息<br><br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>